























import Vue from "vue";
import { MODULE_COLORS } from "@/utility/Constants";

// Vue Components
import AppPage from "@/components/AppPage.vue";

//Model
import { GetTemplatesReqData, GetTemplatesCommand } from "@/model/communication/security/GetTemplatesCommand";
import { GetTemplatesResData } from "@/model/communication/security/GetTemplatesResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import ReferenceConfigurationMainTable from "./ReferenceConfigurationMainTable.vue";
import SecurityConfigurationHistory from "./SecurityConfigurationHistory.vue";

export default Vue.extend({
    components: {
        AppPage,
        ReferenceConfigurationMainTable,
        SecurityConfigurationHistory,
    },

    data() {
        return {
            MODULE_COLORS,
            configurationTemplates: [],
            configurationTemplateLoading: false,
            reqData: null,
            currentPaginationOptions: null,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.configurationTemplateLoading = true;
                let response: GetTemplatesResData = await new GetTemplatesCommand(new GetTemplatesReqData()).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.configurationTemplates = response.configurationTemplates;
                }
            } catch (e) {
                console.log("Something went wrong sending GetTemplatesCommand request ", e);
            }
            this.configurationTemplateLoading = false;
        },

        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },

        onReload() {
            console.debug("Send request to reload data");
            this.sendRequest(this.reqData);
        },

        onFiltersChanged(filters) {
            let newReqData = Object.assign({}, this.reqData);
            newReqData.offset = 0;

            filters.forEach((filter) => {
                newReqData[filter.filterKey] = filter.currentSelections;
            });
            this.$refs.mainTable.backToTheFirst();
            this.sendRequest(newReqData);
        },
    },
    created() {
        this.sendRequest();
    },
});
